import { Box } from '@material-ui/core';
import { generatePath } from 'react-router-dom';

import { useWidth } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/hooks/useWidth';
import { CardOnboardingPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/CardOnboarding/_shared/entities/PaymentMethodDetail/CardOnboardingPaymentMethodDetailEntity';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { Font } from '@/components/shared/components/Font';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';

interface NextActionValidateCardDataProps {
  paymentMethodDetailEntity: CardOnboardingPaymentMethodDetailEntity;
}

export const NextActionValidateCardData = ({ paymentMethodDetailEntity }: NextActionValidateCardDataProps) => {
  const { width, ref } = useWidth<HTMLDivElement>();
  const loanId = paymentMethodDetailEntity.paymentMethodId;

  if (!loanId) {
    return null;
  }

  const validationPath = generatePath(DYNAMIC_PAGE_PATHS.DOCUMENTS_VALIDATION, { loanId });

  return (
    <CustomPaper fill="grey.light">
      <div ref={ref}>
        <Box display="flex" flexDirection={width && width > 600 ? 'row' : 'column'} width="100%" gridGap={24}>
          <FlexColumn gridGap={4} flexGrow={1} minWidth={300}>
            <Font variant="body2" color="title" display="block">
              <Text tId="VALIDATE_CARD_DATA_DESCRIPTION" />
            </Font>
          </FlexColumn>
          <Box flexShrink={0} display="flex" alignItems="center">
            <StandardButton main size="small" onClick={() => window.open(validationPath, '_blank')}>
              <Text tId="VALIDATE_CARD_DATA_CTA" />
            </StandardButton>
          </Box>
        </Box>
      </div>
    </CustomPaper>
  );
};
